import { ReactNode } from 'react'
import { useQuery } from '@tanstack/react-query'
import { configApi } from '../../services/api'

export default function RedLockGuard({ children }: { children: ReactNode }) {
  const { data } = useQuery({
    queryKey: ['red-licenza'],
    queryFn: () => configApi.getRedLicenza().then(r => r.data),
    refetchInterval: 60000,
    staleTime: 30000,
  })

  const { data: solaLettura } = useQuery({
    queryKey: ['red-sola-lettura'],
    queryFn: () => configApi.getRedSolaLettura().then(r => r.data),
    refetchInterval: 60000,
    staleTime: 30000,
  })

  if (data?.bloccato) {
    return (
      <div style={{
        position: 'fixed', inset: 0, zIndex: 99999,
        background: '#0f172a',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        color: '#fff', textAlign: 'center', padding: 24, gap: 16,
      }}>
        <div style={{ fontSize: 56 }}>⚠️</div>
        <div style={{ fontSize: 28, fontWeight: 700 }}>Licenze API scadute</div>
        <div style={{ fontSize: 18, color: '#cbd5e1' }}>Prego rinnovare</div>
      </div>
    )
  }

  const mostraBannerSolaLettura = solaLettura?.attivo && !solaLettura?.puo_gestire

  return (
    <>
      {mostraBannerSolaLettura && (
        <div style={{
          background: '#fef3c7', borderBottom: '1px solid #f59e0b',
          color: '#92400e', fontSize: 13, fontWeight: 500,
          padding: '8px 16px', textAlign: 'center',
        }}>
          🔒 Il modulo RED è in sola lettura: le modifiche sono momentaneamente disabilitate.
        </div>
      )}
      {children}
    </>
  )
}
